module.exports = __webpack_public_path__ + "img/idcard.a35f95cf.svg";